import type { Room } from './hotelDetailsResponse'

export type BadgeVariant = 'best-price' | 'deposit' | 'international'

export interface BadgeStyle {
	gradient: string
	icon: string
	label: string
	zIndex: string
}

export interface BadgeConfig {
	variant: BadgeVariant
	condition: (room: Room) => boolean
}

export const badgeConfigs: BadgeConfig[] = [
	{
		variant: 'best-price',
		condition: (room) => room.isLowestRate ?? false,
	},

	{
		variant: 'international',
		condition: (room) => room.isInternational ?? false,
	},

	{
		variant: 'deposit',
		condition: (room) => room.isLowestDepositRate ?? false,
	},
]

export const getActiveRoomBadges = (room: Room): BadgeVariant[] => {
	return badgeConfigs
		.filter((config) => config.condition(room))
		.map((config) => config.variant)
}
